const getLoadingState = ({ isLoading, error, data, loadingText, emptyText, translate }) => {
    const defaultLoadingText = translate ? translate('common.loading') : loadingText;
    const defaultEmptyText = translate ? translate('common.noData') : emptyText;

    if (isLoading) {
        return <p className='loading'>{defaultLoadingText}</p>;
    }

    if (error) {
        return (
            <p className='error'>
                {translate('common.errors.loadingData')}: <strong>{error.message}</strong>
            </p>
        );
    }

    if (!data) {
        return <p className='warning'>{defaultEmptyText}</p>;
    }

    return null;
};

export default getLoadingState;
